import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiOpenProcessMenu from "src/components/core-components/mui/ByzMuiOpenProcessMenu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";

export const useSurgeryColumns = (): GridColDef[] => {
  const { t } = useTranslate();

  return [
    {
      field: "select",
      headerName: "",
      width: 50,
      renderCell: () => <ByzMuiCheckBox />
    },
    {
      field: "menu",
      headerName: "",
      width: 50,
      renderCell: () => (
        <ByzMuiOpenProcessMenu
          triggerElement={<MoreVertIcon />}
          menuItems={[
            {
              label: t("edit"),
              onClick: () => console.log("Düzenle tıklandı"),
            },
            {
              label: t("delete"),
              onClick: () => console.log("Sil tıklandı"),
              iconColor: "error",
            },
          ]}
        />
      )
    },
    {
      field: "surgeryName",
      flex: 1,
      renderHeader: () => (
        <ByzMuiTypography isTitle>
          {t("surgery-pre-post-preparation.surgery-name")}
        </ByzMuiTypography>
      ),
    },
    {
      field: "plannedDate",
      flex: 1,
      renderHeader: () => (
        <ByzMuiTypography isTitle>
          {t("safety-surgery.planned-operation-time")}
        </ByzMuiTypography>
      ),
    },
    {
      field: "delete",
      width: 80,
      renderHeader: () => (
        <ByzMuiTypography isTitle>
          {t("delete")}
        </ByzMuiTypography>
      ),
      renderCell: () => (
        <IconButton onClick={() => console.log("Silinecek")}>
          <DeleteIcon sx={{ color: "red" }} />
        </IconButton>
      )
    }
  ];
};
